import uniqid from 'uniqid';
import {
    DiJavascript1,
    DiReact,
    DiNodejs,
    DiMongodb,
    DiPython,
    DiGitHub,
    DiJava,
} from "react-icons/di";
import { TbBrandRedux } from "react-icons/tb";
import { FaGithub, FaHtml5, FaCss3, FaPhp, FaPython, FaBootstrap } from "react-icons/fa";
import {
    SiPostgresql, SiNetlify, SiExpress, SiMongodb, SiMysql, SiVercel
} from "react-icons/si";
import './Skills.css';
import { useState } from 'react';

const Skills = () => {
    const [skills, setSkills] = useState()

    return (
        <section className='section skills' id='skills'>
            <h2 className='section__title'>Skills</h2>
            <ul className='skills__list'>
                <li className='skills__list-item btn btn--plain'><DiJavascript1 size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><DiReact size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><DiNodejs size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><DiPython size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><FaGithub size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><SiPostgresql size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'>< SiNetlify size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><SiVercel size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><FaCss3 size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain' style={ { fontWeight: 'bold' } }>Render</li>
                <li className='skills__list-item btn btn--plain'><FaPhp size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><TbBrandRedux size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'>< FaPython size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'>< SiMysql size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><SiExpress size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><FaHtml5 size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><SiMongodb size={ 30 } /></li>
                <li className='skills__list-item btn btn--plain'><FaBootstrap size={ 30 } /></li>



            </ul>
        </section>
    );
};

export default Skills;
